// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testTemplateId } from './TestTemplate';
import { z } from 'zod';
export const testAttributeLineageId = (z.string());
export const testAttributeLineage = z.object({
    id: testAttributeLineageId,
    test_template_id: testTemplateId,
    created_at: z.date(),
});
export const testAttributeLineageInitializer = z.object({
    id: testAttributeLineageId.optional(),
    test_template_id: testTemplateId,
    created_at: z.date().optional(),
});
export const testAttributeLineageMutator = z.object({
    id: testAttributeLineageId.optional(),
    test_template_id: testTemplateId.optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=TestAttributeLineage.js.map